


import { wrapApp } from '@/util/performance-debugger/micro-apps/MicroFrontendAppWrapper';

  import { useEmitter } from '../../composition/useEmitter'
  import { defineComponent } from '@vue/composition-api'
  import { useAppContext } from '../../composition/useAppContext'
  import { trackPendoEvent } from '../../../util/helper'
  import { useScopedStore } from '@/plugins/setupMicroAppStore'
  import { loadRemote } from '@module-federation/runtime'
  import { CopilotEvents } from '@/events'
  let copilotModalComponent: any = {}
  
  export default defineComponent({
    watch: {
      '$route.params.location_id': function (id) {
        // this.mountCopilotModal()
        //TODO: Change the Selected Location in the Store
      },
    },
    mounted() {
      const emitter = useEmitter()
      emitter.on(CopilotEvents.LOAD_COPILOT_MODAL, this.handleCopilotModal)
    },
    beforeDestroy() {
      const emitter = useEmitter()
      emitter.off(CopilotEvents.LOAD_COPILOT_MODAL)
      if (copilotModalComponent?.unmount) {
        copilotModalComponent?.unmount()
        window['copilotApp'] = null
      }
    },
    data() {
      return {
      }
    },
    methods: {
      async handleCopilotModal(params?: { source?: string; url?: string; payload?: Array<{ type: string; message: string }> }) {
        // console.log("Handling Mount Copilot Modal")
        const emitter = useEmitter()
        const eventParams = {
          source: params?.source || 'topbar',
          ...(params?.url && { url: params.url }),
          ...(params?.payload && { payload: params.payload })
        }
        if (copilotModalComponent?.unmount) {
          // console.log("Copilot Modal Component Is Already Mounted so emitting show-copilot-modal event")
          emitter.emit('show-copilot-modal', eventParams)
          return
        }
        // console.log("Mounting Copilot Modal")
        await this.mountCopilotModal()
        // console.log("Emitting show-copilot-modal event")
        emitter.emit('show-copilot-modal', eventParams)
      },
      async mountCopilotModal() {
        try {
          if (copilotModalComponent?.unmount) return
          const route = this.$route
          const router = this.$router
          const emitter = useEmitter()
          console.log("Emitter from CopilotModal.vue", emitter)
          const user = this.$store.getters['user/get']
          const location = await this.$store.getters['locations/getCurrentLocation']
          const store = useScopedStore({
            state: ['locations', 'company', 'user', 'aiCompanyPlan', 'aiLocationPlan'],
            getters: [
              'company/get',
              'user/get',
              'locations/getCurrentLocation',
              'aiCompanyPlan/isSOAEnabled',
              'aiLocationPlan/getSOAOptIn',
              'aiCompanyPlan/getFeatureFlags',
              'aiCompanyPlan/getAffiliateCode',
              'aiLocationPlan/getProductEnabled',
              'aiLocationPlan/getPlan',
              'aiLocationPlan/getSeasonOfAI',
              'aiLocationPlan/getShowSummerOfAIMenu'
            ],
          })
          const userSpecificLanguage = this.$store.state.user?.user?.platformLanguage
          const locationSpecificLanguage = location?.locale_settings?.platform
          const locale = userSpecificLanguage || locationSpecificLanguage || 'en-US'
          const { mountAppContext } = useAppContext()

          const [createApp, page] = await Promise.all([
            loadRemote('copilotApp/vue3').then((m: any) => wrapApp(m.createApp, 'copilotApp', '/tmp/workspace/staging-interop/common/spm-ts/src/pmd/pages/copilot/CopilotModal.vue')),
            loadRemote('copilotApp/CopilotModal').then((m: any) => m.default)
          ])

          copilotModalComponent = createApp(page, {
            route,
            router,
            emitter,
            user,
            store,
            locale,
          })
          mountAppContext({ copilotApp: copilotModalComponent })
          copilotModalComponent.mount(`#copilot-modal`)
        } catch (error) {
          console.error('Error mounting Copilot Modal:', error)
        }
      },
    },
  })
  